import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from "react-router-dom";
import App from './App';

// Bootstrap CSS
import "bootstrap/dist/css/bootstrap.min.css";
// Bootstrap Bundle JS
import "bootstrap/dist/js/bootstrap.bundle.min";
import "bootstrap-icons/font/bootstrap-icons.css";

const rootElement = document.getElementById("root");


const root = ReactDOM.createRoot(rootElement);


root.render(
      <BrowserRouter>
        <App />
      </BrowserRouter>
);

